import { render, staticRenderFns } from "./public-bidding.vue?vue&type=template&id=0bc27153&scoped=true"
import script from "./public-bidding.vue?vue&type=script&lang=js"
export * from "./public-bidding.vue?vue&type=script&lang=js"
import style0 from "./public-bidding.vue?vue&type=style&index=0&id=0bc27153&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc27153",
  null
  
)

export default component.exports